module.exports = __webpack_public_path__ + "static/img/5.c176c45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pc/body/icon-2/5.png
// module id = abl2
// module chunks = 1